import { render, staticRenderFns } from "./surroundBox.vue?vue&type=template&id=6a093d82&scoped=true"
import script from "./surroundBox.vue?vue&type=script&lang=js"
export * from "./surroundBox.vue?vue&type=script&lang=js"
import style0 from "./surroundBox.vue?vue&type=style&index=0&id=6a093d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a093d82",
  null
  
)

export default component.exports